import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function AwardIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M5.12 7.513 2.87 3.428c-.259-.47-.388-.704-.367-.897a.6.6 0 0 1 .242-.418C2.9 2 3.164 2 3.696 2h1.322c.197 0 .296 0 .385.029a.6.6 0 0 1 .211.123c.07.062.12.148.22.32L8 6.2l2.166-3.727c.1-.173.15-.259.22-.321a.6.6 0 0 1 .211-.123C10.686 2 10.785 2 10.982 2h1.322c.531 0 .797 0 .951.113a.6.6 0 0 1 .243.418c.021.193-.108.428-.367.897L10.88 7.513M7.112 9.2 8 8.6v3m-.74 0h1.48m1.98-4.258a3.94 3.94 0 0 1 0 5.516 3.81 3.81 0 0 1-5.44 0 3.94 3.94 0 0 1 0-5.516 3.81 3.81 0 0 1 5.44 0" /></svg>
  );
}

export default AwardIcon;
